var script = document.createElement('script')
script.src = 'https://www.googletagmanager.com/gtag/js?id=G-DKRVD7BS64'
script.async = true
document.body.appendChild(script)

window.dataLayer = window.dataLayer || []
function gtag() {
  window.dataLayer.push(arguments)
}
window.gtag = gtag

gtag('js', new Date())
gtag('config', 'G-DKRVD7BS64')
